  <pos-app-spinner [show]="setIframeBaseUrlTimeout"></pos-app-spinner>
<div class="col">
  <div>
    <div class="card-container card">
      <div class="card-header" style="background-color: #e7e6e6">
        <div class="card-header-title">
          <h4 class="card-title text-uppercase"><label>Related sites</label></h4>
        </div>
      </div>

      <div class="d-flex justify-content-evenly">
        <div class="d-flex align-items-center" *ngIf="scrollContainer?.scrollWidth > scrollContainer?.clientWidth" (click)="scrollLeftb()">
          <mat-icon style="font-size: 40px; height: 40px; width: 40px">keyboard_arrow_left</mat-icon>
        </div>
        <div
          class="d-flex overflow-auto my-related-component-list"
          style="scroll-behavior: smooth; scrollbar-width: none; -ms-overflow-style: none"
          #scrollContainer
        >
          <style>
            .my-related-component-list::-webkit-scrollbar {
              display: none;
            }
          </style>
          <div *ngFor="let myHelpComponent of myHelpComponents; let i = index" class="d-flex justify-content-center p-2">
            <div class="d-flex flex-column align-items-center py-2 px-4">
              <div class="card card-sites" (click)="setIframeBaseUrl(myHelpComponent)">
                <div *ngIf="!myHelpComponent.icon" class="logo-image"></div>
                <div *ngIf="myHelpComponent.icon" class="logo-image" [ngStyle]="{ 'background-image': 'url(' + myHelpComponent.icon + ')' }"></div>
              </div>
              <div class="d-flex justify-content-center py-2 text-center">
                <label style="white-space: nowrap">{{ myHelpComponent.label }}</label>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-end align-items-center"
          *ngIf="scrollContainer?.scrollWidth > scrollContainer?.clientWidth"
          (click)="scrollRightb()"
        >
          <mat-icon style="font-size: 40px; height: 40px; width: 40px">keyboard_arrow_right</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>
